import styled from "styled-components";
import { colors } from "../../../../styles/variables";

export const StyledDiscount = styled.div`
  color: ${colors.gray600};
  display: flex;
  justify-content: flex-start;
  gap: 5px;
`;

export const StyledDiscountDetails = styled.div`
  color: ${colors.gray600};
  font-size: 13px;
  word-break: break-all;
`;
